export default "__VITE_ASSET__Ben1OuOM__"